<template>
  <div class="container">
    <div class="notification is-warning has-text-centered"><strong>404</strong> Page not found.</div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>
